/**
 * Utility to safely load and access mxGraph components
 */

// Track loading state to prevent multiple load attempts
let isLoadingScript = false;

/**
 * Dynamically loads the mxClient.js script if it's not already loaded
 */
export const ensureMxGraphLoaded = (): Promise<boolean> => {
  // If mxGraph is already available, return immediately
  if ((window as any).mxCell) {
    return Promise.resolve(true);
  }
  
  return new Promise((resolve, reject) => {
    if (isLoadingScript) {
      // Script is already being loaded, wait a bit and check again
      const checkInterval = setInterval(() => {
        if ((window as any).mxCell) {
          clearInterval(checkInterval);
          resolve(true);
        }
      }, 100);
      
      // Add timeout to avoid infinite waiting
      setTimeout(() => {
        clearInterval(checkInterval);
        reject(new Error('Timed out waiting for mxGraph to load'));
      }, 10000);
      
      return;
    }
    
    isLoadingScript = true;
    
    // Create script element
    const script = document.createElement('script');
    script.src = '/external/mxClient.js';
    script.async = true;
    
    // Set up event handlers
    script.onload = () => {
      if ((window as any).mxCell) {
        console.log('mxClient.js loaded successfully');
        isLoadingScript = false;
        resolve(true);
      } else {
        console.error('mxClient.js loaded but mxCell not found');
        isLoadingScript = false;
        reject(new Error('mxClient.js loaded but mxCell not found'));
      }
    };
    
    script.onerror = () => {
      console.error('Failed to load mxClient.js');
      isLoadingScript = false;
      reject(new Error('Failed to load mxClient.js'));
    };
    
    // Add the script to the document
    document.head.appendChild(script);
  });
  
};

